import React, { useRef } from "react";

//Importar íconos de Material UI.
import { Image, InsertDriveFile } from '@mui/icons-material/';

//Importar hook personalizado para calcular la posición en función a la relación.
import useRefCalculator from "../../../../../hooks/useRefCalculator";
import useClickOutside from "../../../../../hooks/useClickOutside";

// MenuSendFiles: Componenete que renderiza el menu para seleccionar el tipo de contenido multimedia a subirse.

const MenuSendFiles = ({ setTypeFile, clickRef, setOpenMenuFiles, onSelectedFile }) => {

    const menuRef = useRef(null); // Referencia al contenedor del menú
    const inputRef = useRef(null); // Referencia al input de tipo file
    const searchPosition = useRefCalculator(clickRef, -750, -550); //Usar el hook para calcular la posición del menú para asignar.
    const iconsSyle = { fontSize: "20px", marginRight: "10px", width: "35px", color: "#808080" };

    //Llamar a la función de callback en Chat.jsx pasándole el valor del archivo seleccionado.
    const handleFileChange = (event) => {onSelectedFile(event.target.files); console.log("salió el valor", event.target.files)};

    useClickOutside(menuRef, () => setOpenMenuFiles(false));

    return (
        <>
            {searchPosition.top !== 0 && (
                <div ref={menuRef} className="container-menu__newFile" >
                    <div className="menu-butto-ns__newFile" >

                        <label className="container-operador__name" htmlFor="imageInput">
                            <Image sx={iconsSyle} />
                            <span className="file-type-send">Imagen</span>
                            <input type="file" id="imageInput" ref={inputRef}
                                onChange={handleFileChange} onClick={() => setTypeFile("image")}
                                multiple 
                                accept=".png, .jpg, .jpeg"/>
                        </label>

                        <label className="container-operador__name" htmlFor="fileInput">
                            <InsertDriveFile sx={iconsSyle} />
                            <span className="file-type-send">Documento</span>
                            <input type="file" id="fileInput" ref={inputRef}
                                onChange={handleFileChange} onClick={() => setTypeFile("document")}
                                multiple 
                                accept=".pdf, .word"/>
                        </label>
                    </div>
                </div>
            )}
        </>
    );
};

export default MenuSendFiles;
